import { render } from "./BindUser.vue?vue&type=template&id=465a61c8"
import script from "./BindUser.vue?vue&type=script&lang=js"
export * from "./BindUser.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__